import React, { Component } from "react";
import { NavBar, SideBar, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import clienteModel from "../../models/cliente";
//import historicoFaturamentoModel from "../../models/historicoFaturamento";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatarReal } from "../../utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AsyncSelect from "react-select/async";
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "debounce-promise";
PouchDB.plugin(PouchdbFind);

class TituloAtraso extends Component {
  constructor(props) {
    super(props);
    this.handleChangeCliente = this.handleChangeCliente.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeQueryBusca = this.onChangeQueryBusca.bind(this);
    this.buscarItens = this.buscarItens.bind(this);
    this.filtrarItens = this.filtrarItens.bind(this);
    this.notificar = this.notificar.bind(this);
    this.promiseOptions = this.promiseOptions.bind(this);
    this.transformDataComboBoxCliente =
      this.transformDataComboBoxCliente.bind(this);
    this.filtrar = this.filtrar.bind(this);
    this.buscarTitulos = this.buscarTitulos.bind(this);

    this.debouncedLoadOptions = debounce(
      (inputValue) => this.promiseOptions(inputValue),
      500,
      {
        leading: true,
      }
    );

    this.state = {
      clientes: [],
      clienteSelecionado: null,
      startDate: new Date(),
      dataInicial: new Date(),
      dataFinal: new Date(),
      busca: "",
      itens: [],
      itensBkp: [],
      exibirLoading: false,
      skip: 0,
      db: null,
      titulos: [],
      exibirMensagem: false,
      valorDebitos: 0,
    };
  }

  async componentDidMount() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    this.setState({ db });
  }

  handleChangeCliente(clienteSelecionado) {
    this.setState(
      {
        clienteSelecionado,
      },
      () => {
        this.setState({
          itens: [],
          itensBkp: [],
          skip: 0,
          hasMore: true,
        });
      }
    );
  }

  onChangeDate(tipo, agt) {
    this.setState({ [tipo]: agt });
  }

  onChangeQueryBusca(busca) {
    this.setState({ busca }, () => this.filtrarItens());
  }

  async filtrar(exibirLoading = true) {
    if (this.state.clienteSelecionado === null) {
      this.notificar("warning", "Selecione o cliente");
      return false;
    }

    this.setState({ exibirLoading: exibirLoading }, async () => {
      let itens = await this.buscarItens();
      let itensBkp = [].concat(itens);
      let hasMore = true;
      if (itens.length === 0 && this.state.itensBkp.length === 0) {
        this.notificar("warning", "Sua busca não retornou nenhum resultado.");
        hasMore = false;
      } else {
        if (this.state.busca !== "") {
          let busca = this.state.busca.toUpperCase();
          itens = itens.filter((item) => {
            if (item.idIntegracao.toString().search(busca.toString()) !== -1) {
              return true;
            }
            if (item.desc.search(busca) !== -1) {
              return true;
            }
            return false;
          });
        }
      }

      if (itens.length === 0) {
        hasMore = false;
      }

      this.setState(
        {
          itens: this.state.itens.concat(itens),
          itensBkp: this.state.itensBkp.concat(itensBkp),
          hasMore,
          skip: this.state.skip + 5,
        },
        () => {
          this.setState({ exibirLoading: false });
        }
      );
    });
  }

  async buscarItens() {
    let obj = {
      cliente: this.state.clienteSelecionado.idIntegracao,
      dtInicio: this.state.dataInicial,
      dtFinal: this.state.dataFinal,
      skip: this.state.skip,
    };
    let itens = [];
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/historicoItens`,
        obj,
        this.props.parameters()
      )
      .then((response) => {
        itens = response.data;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
    return itens;
  }
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> REVER LÓGICA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
  async filtrarItens() {
    let itens = this.state.itensBkp;
    let busca = this.state.busca.toUpperCase();
    itens = itens.filter((item) => {
      if (item.cod.toString().search(busca.toString()) !== -1) {
        return true;
      }
      if (item.desc.search(busca) !== -1) {
        return true;
      }
      return false;
    });

    this.setState({ itens });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  promiseOptions(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          // let clientes = await clienteModel.findAll(this.state.db);
          let clientes = [];
          clientes = this.transformDataComboBoxCliente(clientes);
          this.setState({ clientes });

          resolve(clientes);
        } else {
          let aux = inputValue.substr(0, 1);
          let len = 2;
          if (aux == "&" || aux == "%") len = 3;
          if (inputValue.length >= len) {
            let clientes = await clienteModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            clientes = this.transformDataComboBoxCliente(clientes);
            this.setState({ clientes });
            resolve(clientes);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  transformDataComboBoxCliente(lista) {
    lista = lista.map((item) => {
      item.value = item.descFormat;
      item.label = item.descFormat;
      return item;
    });
    return lista;
  }

  async buscarTitulos() {
    let cliente = this.state.clienteSelecionado;
    if (cliente === null) {
      return false;
    } else {
      let titulos = [];

      // let titulosBanco = await clienteModel.buscarTitulos(
      //   this.state.db,
      //   cliente.idIntegracao
      // );

      let valorDebitos = 0;

      await axios
        .post(
          `${this.props.getBaseUrlBackendHibrido()}/api/buscar-titulos-atraso`,
          { idPessoa: cliente.idIntegracao }
        )
        .then((response) => {
          titulos = response.data.titulosAtraso;

          if (titulos.length) {
            for (let item of titulos) {
              valorDebitos = valorDebitos + item.valorPendente;
            }
          }

          this.setState({ titulos, exibirMensagem: true, valorDebitos });
        })
        .catch((error) => {
          console.log(error);
          if (error.response !== undefined) {
            if (error.response.status === 401) {
              this.props.logout();
            }
            if (error.response.status === 403) {
              this.props.history.push("/home");
            }
          }
        });
    }
  }
  async buscarTitulosBkp() {
    let cliente = this.state.clienteSelecionado;
    if (cliente === null) {
      return false;
    } else {
      let titulos = [];

      let titulosBanco = await clienteModel.buscarTitulos(
        this.state.db,
        cliente.idIntegracao
      );

      let valorDebitos = 0;

      if (titulosBanco.length) {
        titulos = titulosBanco[0].titulos;
        valorDebitos = titulosBanco[0].vlDebitos;
      }

      this.setState({ titulos, exibirMensagem: true, valorDebitos });
    }
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Títulos em Atraso" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"titulosAtraso"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Histórico de Vendas"
                  description="Consultar histórico de vendas"
                /> */}
                <div id="container-historico-vendas">
                  <div className="container card">
                    <div className="row" style={{ padding: "0px 15px" }}>
                      <div className="form-group col-5 pd-pedido">
                        <label className="font-size-14">Cliente</label>
                        <AsyncSelect
                          cacheOptions
                          defaultOptions
                          loadOptions={(inputValue) =>
                            this.debouncedLoadOptions(inputValue)
                          }
                          value={this.state.clienteSelecionado}
                          onChange={(item) => this.handleChangeCliente(item)}
                          placeholder="Pesquise pela fantasia ou código"
                          className="font-size-14"
                        />
                      </div>

                      <div className="form-group col-1 pd-pedido">
                        <div
                          className=""
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#434343",
                            fontSize: "25px",
                            cursor: "pointer",
                            marginTop: "29px",
                          }}
                          onClick={this.buscarTitulos}
                        >
                          <i className="fa fa-filter"></i>
                        </div>
                      </div>
                    </div>

                    {this.state.itensBkp.length > 0 && (
                      <div
                        className="row"
                        style={{ marginBottom: "16px", padding: "0px 15px" }}
                      >
                        <div className="col-5 pd-pedido">
                          <div style={{ position: "absolute", padding: "6px" }}>
                            <i
                              className="fa fa-search"
                              style={{
                                color: "#7ED321",
                                fontSize: "20px",
                              }}
                            ></i>
                          </div>
                          <input
                            className="form-control font-size-13"
                            type="text"
                            placeholder="Para filtrar digite código ou descrição do item"
                            style={{ padding: ".375rem 2.10rem" }}
                            value={this.state.busca}
                            onChange={(e) =>
                              this.onChangeQueryBusca(e.target.value)
                            }
                            disabled={
                              this.state.itensBkp.length === 0 ? true : false
                            }
                          />{" "}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="container-itens-historico">
                    <div className="container card">
                      {this.state.exibirLoading && (
                        <div id="loading-bar-spinner" className="spinner">
                          <div className="spinner-icon"></div>
                        </div>
                      )}

                      <div className="itens-historico">
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead className="thead-dark thead-site">
                              <tr>
                                <th className="col-3 padding-coluna-titulos text-center">
                                  Título
                                </th>
                                <th className="col-3 padding-coluna-titulos text-center">
                                  Emissão
                                </th>
                                <th className="col-3 padding-coluna-titulos text-center">
                                  Vencimento
                                </th>
                                <th className="col-3 padding-coluna-titulos text-right">
                                  Valor
                                </th>
                              </tr>
                            </thead>

                            {this.state.clienteSelecionado !== null &&
                              this.state.titulos.length === 0 &&
                              this.state.exibirMensagem && (
                                <tbody>
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Este cliente não possuí nenhum título em
                                      atraso.
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                            <tbody>
                              {this.state.titulos.map((item, key) => {
                                return (
                                  <tr key={key}>
                                    <td className="text-center">
                                      {item.nrTitulo} - {item.descricao}
                                    </td>
                                    <td className="text-center">
                                      {moment(item.emissao).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td className="text-center">
                                      {moment(item.vencimento).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td className="text-right">
                                      R$ {formatarReal(item.valorPendente)}
                                    </td>
                                  </tr>
                                );
                              })}
                              {this.state.titulos.length > 0 && (
                                <tr>
                                  <td
                                    colSpan={4}
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                      textAlign: "right",
                                    }}
                                  >
                                    Total dos títulos: R${" "}
                                    {formatarReal(this.state.valorDebitos)}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TituloAtraso;
